import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from '@coolblue-development/freddy';
import { useFormatFullTextDay, useFormatTime, } from '@coolblue-development/next-formatting-utils/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useStoreAvailability } from '../../../../context/StoreAvailabilityContext.js';
import { useTranslation } from '../../../../i18n/useTranslation.js';
export const OpeningHours = ({ schedule }) => {
    const { timeTravelOverride } = useStoreAvailability();
    const { isInternalUser } = useRequestContext();
    const { t } = useTranslation('storesStockOverlay');
    const formattedDay = useFormatFullTextDay(new Date(schedule.scheduleDate));
    const formattedOpeningHour = useFormatTime(new Date(`${schedule.scheduleDate}T${schedule.openTime}`));
    const formattedClosingHour = useFormatTime(new Date(`${schedule.scheduleDate}T${schedule.closeTime}`));
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const isToday = now.toDateString() === new Date(schedule.scheduleDate).toDateString();
    return (_jsxs(Flex, { justifyContent: "space-between", sx: { fontWeight: isToday ? 'bold' : 'normal' }, children: [_jsx(Box, { sx: { textTransform: 'capitalize' }, children: formattedDay }), _jsx(Box, { "data-testid": isInternalUser ? 'store-opening-hours' : undefined, children: schedule.isClosed
                    ? t('openingHours.closed')
                    : `${formattedOpeningHour} - ${formattedClosingHour} ${t('openingHours.hour')}` })] }));
};
//# sourceMappingURL=OpeningHours.js.map